import { useMemo } from "react";
import { useTranslation } from "next-i18next";
import { makeOption } from "@/shared/utils/select";
import { UL_LANGUAGES } from "@/shared/utils/multilang/constants";
import { UL_NEXT_LANGUAGES } from "@/shared/utils/multilang/constants";

const useUiLanguagesTranslated = (app = "") => {
  const { t } = useTranslation();

  return useMemo(() => {
    return (app === "next" ? UL_NEXT_LANGUAGES : UL_LANGUAGES).map((language) => {
      return makeOption(language.id, t(language.key));
    });
  }, [t, app]);
};

export default useUiLanguagesTranslated;
